exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".controls[data-v-aa3e4874]{display:flex;justify-content:flex-end;padding:.75rem}", ""]);

// exports
